import { PAYMENT_METHODS } from '../../constants/src/providers/payment-methods';
import type { TPaymentMethod } from '../../interfaces';
import { useMediaQuery } from '../../ui/react/src';

const LABEL_PAY = 'Pagar';
const LABEL_WEBPAY = 'Continuar con Webpay';

export const useButtonText = (method: TPaymentMethod) => {
  const isMobile = useMediaQuery('lg');
  const isMobileWebpay = isMobile && method === PAYMENT_METHODS.WEBPAY;

  if (isMobileWebpay) return LABEL_WEBPAY;

  return LABEL_PAY;
};
